<template lang="html">
  <!-- CHIP -->
  <div
    class="d-flex flex-wrap"
    :class="{ 'py-1': isColumn }"
    style="gap: 4px;"
    :style="{ 'flex-direction': orientation }"
  >
    <slot v-if="toSingleElementArray.length == 0" name="noResults">
      -
    </slot>
    <v-chip
      v-else
      v-for="(chip, index) in toSingleElementArray"
      style="max-width: fit-content;"
      v-bind="$attrs"
      :key="index"
      :small="small"
      :close="close"
      @click="handleChipClick(chip)"
      @click:close="handleChipClose(index)"
    >
      <slot v-bind="{ chip, index }" name="chip">
        {{ chip }}
      </slot>
    </v-chip>
  </div>  
</template>

<script>
export default {
  props: {
    //array or string of our chips e.g. ['pending', 'draft', 'approved'] or 'pending'
    chips: {
      type: [String, Array],
      default: () => [],
    },
    //can be 'row' or 'column'
    orientation: {
      type: String,
      default: 'row',
      validator(value) {
        return ['row', 'column'].includes(value);
      },
    },
    small: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    toSingleElementArray() {
      if (this.chips)
        return Array.isArray(this.chips) ? [...this.chips] : [this.chips];
      else
        return [];
    },
    isColumn() {
      return this.orientation == 'column';
    },
  },
  methods: {
    handleChipClick(chip) {
      this.$emit('click:chip', chip);
    },
    handleChipClose(index) {
      this.$emit('click:close', index);
    },
  }
};
</script>

<style lang="scss" scoped>
</style>